import { render, staticRenderFns } from "./HengpayTransaction.vue?vue&type=template&id=62da5d34"
import script from "./HengpayTransaction.vue?vue&type=script&lang=js"
export * from "./HengpayTransaction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports